export const mapB2CTenantToLanding = (tenantData) => {
  const theme = tenantData?.theme || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero = tenantData?.hero || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    branchId:    tenantData?.branchId,
    userId:      tenantData?.userId,
    logoUrl:     tenantData?.branding?.logoUrl,
    companyName: tenantData?.branding?.companyName || 'Travel Agency',
    brandName:   tenantData?.branding?.brandName   || 'Travel Agency',

    email:    tenantData?.branding?.email    || 'info@travelagency.com',
    phones:   tenantData?.branding?.phones   || '9000000000',
    whatsapp: tenantData?.branding?.whatsapp || '9000000000',
    socials:  tenantData?.branding?.socials  || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},
    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,

    topBarBg:   topBar.bgColor   || '#060d1e',
    topBarText: topBar.textColor || '#ffffff',
    headerBg:   header.bgColor   || 'rgba(6,13,30,0.9)',
    headerText: header.textColor || '#ffffff',
    footerBg:   footer.bgColor   || '#030b18',
    footerText: footer.textColor || '#ffffff',

    headingFont: tenantData?.branding?.headingFont || 'Plus Jakarta Sans',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Inter',

    heroData: {
      flights: {
        title:     hero.flights?.title    || 'Fly Smarter. Travel Further.',
        subTitle:  hero.flights?.subTitle || 'Book flights at the best prices with zero hidden fees.',
        textColor: hero.flights?.textColor || '#ffffff',
        bgImage:   hero.flights?.bgImage,
      },
      hotels: {
        title:     hero.hotels?.title    || 'Stay Where You Belong.',
        subTitle:  hero.hotels?.subTitle || 'Handpicked hotels for every budget and style.',
        textColor: hero.hotels?.textColor || '#ffffff',
        bgImage:   hero.hotels?.bgImage,
      },
      holidays: {
        title:     hero.holidays?.title    || 'Craft Your Perfect Escape.',
        subTitle:  hero.holidays?.subTitle || 'Curated holiday packages tailored just for you.',
        textColor: hero.holidays?.textColor || '#ffffff',
        bgImage:   hero.holidays?.bgImage,
      },
      sightseeing: {
        title:     hero.sightseeing?.title    || 'Discover Hidden Gems.',
        subTitle:  hero.sightseeing?.subTitle || 'Unforgettable experiences at every destination.',
        textColor: hero.sightseeing?.textColor || '#ffffff',
        bgImage:   hero.sightseeing?.bgImage,
      },
    },
  };
};

export const getB2CColors_T37 = (landingData) => {
  const c1 = landingData.themeColor1 || '#0ea5e9';
  return {
    theme1:     c1,
    theme2:     landingData.footerBg   || '#030b18',
    theme3:     landingData.headerBg   || 'rgba(6,13,30,0.9)',
    theme4:     landingData.themeColor4 || '#060d1e',
    theme5:     landingData.themeColor5 || '#ffffff',
    accent:     landingData.themeColor2 || '#f97316',
    headerText: landingData.headerText || '#ffffff',
    footerText: landingData.footerText || '#ffffff',
    topBarBg:   landingData.topBarBg   || '#060d1e',
    topBarText: landingData.topBarText || '#ffffff',
  };
};
